export enum ActionTypes {
  CreateAlert = 'createAlert',
  DeleteAlert = 'deleteAlert',
  ShowModal = 'showModal',
  HideModal = 'hideModal',
}
